import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, TabsList, TabsTrigger, type QuickFilter } from '@bliks-io/ui';

type PublishFilter = 'all' | 'published' | 'draft';

/** The status quick filter both partner content lists share. */
export function usePublishFilter() {
  const { t } = useTranslation();
  const [filter, setFilter] = useState<PublishFilter>('all');

  const matches = useCallback(
    (published: boolean) => filter === 'all' || published === (filter === 'published'),
    [filter]
  );

  const quickFilter: QuickFilter = {
    id: 'status',
    label: t('partnerContent.columns.status'),
    render: () => (
      <Tabs value={filter} onValueChange={(value) => setFilter(value as PublishFilter)}>
        <TabsList>
          <TabsTrigger value="all">{t('partnerContent.filter.all')}</TabsTrigger>
          <TabsTrigger value="published">{t('partnerContent.status.published')}</TabsTrigger>
          <TabsTrigger value="draft">{t('partnerContent.status.draft')}</TabsTrigger>
        </TabsList>
      </Tabs>
    )
  };

  return { matches, quickFilter };
}
